import { LicenseInfo } from '@mui/x-license-pro';
import { initAgGridUi } from 'fso-fincrime-ag-grid-ui';
import {
  AuthProviderWrapper,
  ErrorPage,
  handleReRenderEvent,
  initI18nextSdkUi,
  initializeAuthProvider,
} from 'fso-fincrime-sdk-ui';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
LicenseInfo.setLicenseKey(window.__RUNTIME_CONFIG__?.REACT_APP_MUI_LICENSE_KEY);

// Initialize critical SDK i18n
initI18nextSdkUi();

/**
 * Render the application, eagerly init required libs, then prefetch remaining feature libs.
 */
const renderApp = (): void => {
  root.render(
    <React.StrictMode>
      <CookiesProvider>
        <AuthProviderWrapper>
          <App />
        </AuthProviderWrapper>
      </CookiesProvider>
    </React.StrictMode>
  );

  try {
    initAgGridUi();
  } catch (error) {
    console.error('Failed to initialize ag-grid UI eagerly', error);
  }
};

// Initialize auth provider and then render the app
initializeAuthProvider()
  .then(() => {
    renderApp();
    handleReRenderEvent(renderApp);
  })
  .catch((error) => {
    console.error(
      'Auth provider initialization failed. This may be due to network issues or invalid configuration :',
      error
    );

    root.render(
      <React.StrictMode>
        <ErrorPage pageType="500" />
      </React.StrictMode>
    );
  });

// Performance measurement - won't block rendering
setTimeout(() => {
  reportWebVitals();
}, 0);
